// src/pages/NotFound.js
import React from "react";
import { Box, Typography, Button, Paper } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Notfound from "../../assets/images/notfound.svg";

const NotFound = () => {
    const navigate = useNavigate();

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: "100vh",
                textAlign: "center",
                backgroundColor: "background.default",
                width: "80vw",
                // marginTop: "-50px",
            }}
        >
            <Paper sx={{ padding: "60px", borderRadius: "20px" }}>
                <img src={Notfound} alt="Notfound" />
                <Typography variant="h2" component="h1">
                    404
                </Typography>
                <Typography variant="h3" component="h1" gutterBottom>
                    Page Not Found
                </Typography>
                <Typography variant="h5" component="h2" gutterBottom>
                    The page you are looking for doesn't exist or has been
                    moved.
                </Typography>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => navigate("/dashboard")}
                    sx={{ mt: 4 }}
                >
                    Go back to Dashboard
                </Button>
            </Paper>
        </Box>
    );
};

export default NotFound;
